module.exports = __webpack_public_path__ + "static/media/roundedrect-tertiary-wide@3x.ee3726ef.png";